import React from 'react';
import './Timer.css';

const Timer = ({ timeLeft }) => {
  const getTimerClass = () => {
    if (timeLeft <= 2) return 'timer critical';
    if (timeLeft <= 3) return 'timer warning';
    return 'timer';
  };

  const circumference = 2 * Math.PI * 45; // radius = 45
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (timeLeft / 5) * circumference;

  return (
    <div className={getTimerClass()}>
      <div className="timer-circle">
        <svg width="100" height="100" viewBox="0 0 100 100">
          <circle
            cx="50"
            cy="50"
            r="45"
            stroke="#e0e0e0"
            strokeWidth="8"
            fill="transparent"
          />
          <circle
            cx="50"
            cy="50"
            r="45"
            stroke="currentColor"
            strokeWidth="8"
            fill="transparent"
            strokeLinecap="round"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            transform="rotate(-90 50 50)"
            className="timer-progress"
          />
        </svg>
        <div className="timer-number">{timeLeft}</div>
      </div>
      <div className="timer-label">ثانية</div>
    </div>
  );
};

export default Timer;
